import MomentUtils from '@date-io/moment';
import * as MD from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Dispatch } from 'redux';
import { Home } from '../Pages/Home';
import { Login } from '../Pages/Login';
import { NewPassword } from '../Pages/NewPassword';
import { Password } from '../Pages/Password';
import { ResetPassword } from '../Pages/ResetPassword';
import { UpdatePassword } from '../Pages/UpdatePassword';
import { AppsManagement } from '../Pages/AppsManagement';
import { ResourcesManagement } from '../Pages/ResourcesManagement';
import { UserManagement } from '../Pages/UserManagement';
import { IApplicationState } from '../Store';
import { logout } from '../Store/User/Actions';
import { IUserState } from '../Store/User/Types';
import { isDateExpired } from '../Utils/Various';

const styles = MD.createStyles({
	container: {
		userSelect: 'none',
	},
});

interface IPropsFromState {
	user: IUserState;
}

interface IPropsFromDispatch {
	logout: typeof logout;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}>;

export class RouterComponent extends React.Component<AllProps> {
	public render(): React.ReactNode {
		return (
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<MD.CssBaseline />
				<MD.Grid
					container={true}
					direction="row"
					justifyContent="center"
					alignItems="center"
					style={{ height: '100%' }}
				>
					{isDateExpired(this.props.user.expires)
						? this.loggedIn()
						: this.notLoggedIn()}
				</MD.Grid>
			</MuiPickersUtilsProvider>
		);
	}

	private loggedIn(): React.ReactNode {
		return this.props.user.groupID === 2
			? this.adminRoute()
			: this.userRoute();
	}

	private userRoute(): React.ReactNode {
		return (
			<Switch>
				<Route
					exact
					path="/login"
					render={() => {
						return <Redirect to="/" />;
					}}
				/>
				<Route
					exact
					path="/logout"
					render={() => {
						this.props.logout();
						return <Redirect to="/login" />;
					}}
				/>
				<Route exact path="/home" component={Home} />
				<Route exact path="/reset" component={ResetPassword} />
				<Route path="/update_password" component={UpdatePassword} />
				<Route exact path="/new_password" component={NewPassword} />
				<Route
					exact
					path="/users/:type/:groupName"
					component={UserManagement}
				/>
				<Route exact path="/users/:type" component={UserManagement} />
				<Route
					exact
					path="/"
					render={() => {
						return <Redirect to="/users/users" />;
					}}
				/>
				<Route exact path="/password/:type" component={Password} />
				<Route exact path="/password" component={Password} />
				<Route component={() => <div>404 - Not Found</div>} />
			</Switch>
		);
	}

	private adminRoute(): React.ReactNode {
		return (
			<Switch>
				<Route
					exact
					path="/login"
					render={() => {
						return <Redirect to="/" />;
					}}
				/>
				<Route
					exact
					path="/logout"
					render={() => {
						this.props.logout();
						return <Redirect to="/login" />;
					}}
				/>
				<Route exact path="/home" component={Home} />
				<Route exact path="/reset" component={ResetPassword} />
				<Route path="/update_password" component={UpdatePassword} />
				<Route exact path="/new_password" component={NewPassword} />
				<Route
					exact
					path="/users/:type/:groupName"
					component={UserManagement}
				/>
				<Route exact path="/users/:type" component={UserManagement} />
				<Route
					exact
					path="/"
					render={() => {
						return <Redirect to="/users/users" />;
					}}
				/>
				<Route
					exact
					path="/apps/:type/:groupName"
					component={AppsManagement}
				/>
				<Route exact path="/apps/:type" component={AppsManagement} />
				<Route
					exact
					path="/ressources/:type/:groupName"
					component={ResourcesManagement}
				/>
				<Route
					exact
					path="/ressources/:type"
					component={ResourcesManagement}
				/>
				<Route exact path="/password/:type" component={Password} />
				<Route exact path="/password" component={Password} />
				<Route component={() => <div>404 - Not Found</div>} />
			</Switch>
		);
	}

	private notLoggedIn(): React.ReactNode {
		return (
			<Switch>
				<Route
					exact
					path="/"
					render={() => {
						return <Redirect to="/login" />;
					}}
				/>
				<Route exact path="/login" component={Login} />
				<Route exact path="/reset" component={ResetPassword} />
				<Route path="/update_password" component={UpdatePassword} />
				<Route exact path="/new_password" component={NewPassword} />
				<Route exact path="/password/:type" component={Password} />
				<Route
					component={() => {
						return <Redirect to="/login" />;
					}}
				/>
			</Switch>
		);
	}
}

const mapStateToProps = ({ user }: IApplicationState) => ({
	user,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	logout: () => dispatch(logout()),
});

export const Router = MD.withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(RouterComponent) as any
);
